import { Promise } from 'es6-promise';

import { Node } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

type NodeType = "agent" | "container";

interface INodeStates {
    nodeId?: string
}

function toStateObject(ids: string[], states: any[]) {
    if (Array.isArray(states)) {
        return {
            [ids[0]]: states
        };
    }

    return states;
}

function chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}

function fetchStates(requesterId: string, nodeType: NodeType, params): Promise<any> {
    const CHUNKSIZE = 200;

    // If caller provided many agent or container IDs, split into chunks to avoid oversized requests
    if (params) {
        const idKey = Array.isArray(params.aId) ? 'aId' : (Array.isArray(params.cId) ? 'cId' : null);
        if (idKey && params[idKey].length > CHUNKSIZE) {
            const chunks = chunkArray(params[idKey] as any[], CHUNKSIZE);
            const requests = chunks.map(chunk => {
                const reqParams = Object.assign({}, params, { [idKey]: chunk });
                return request.post(`${nodeType.toString()}/state`, reqParams);
            });

            return Promise.all(requests).then((results: any[]) => {
                const merged: { [key: string]: any[] } = {};

                results.forEach((res: any, idx: number) => {
                    const chunk = chunks[idx];
                    if (!res) return;

                    // Merge states for each chunked request into a single object keyed by node ID
                    Object.keys(res).forEach(k => {
                        merged[k] = merged[k] ? merged[k].concat(res[k] || []) : (res[k] || []);
                    });
                    return;
                });

                return merged;
            });
        }
    }

    // For small requests, just make a single call
    return request.post(`${nodeType.toString()}/state`, params);
}

function listStates(requesterId: string, nodeType: NodeType, query): Function {
    return dispatch => {
        dispatch(new FSA(Node.FETCH_STATE_REQUEST).addMeta({ requesterId }).data);

        return fetchStates(requesterId, nodeType, query).then((states: any[]) => {
            const ids = query.aId || query.cId;
            return dispatch(new FSA(Node.FETCH_STATE_SUCCESS).addPayload(toStateObject(ids, states)).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(Node.FETCH_STATE_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    INodeStates,
    toStateObject,
    fetchStates,
    listStates,
};


// WEBPACK FOOTER //
// ./src/actions/NodeState.ts